import { render, staticRenderFns } from "./CardSidebarTabDetails.vue?vue&type=template&id=77158611&scoped=true&"
import script from "./CardSidebarTabDetails.vue?vue&type=script&lang=js&"
export * from "./CardSidebarTabDetails.vue?vue&type=script&lang=js&"
import style0 from "./CardSidebarTabDetails.vue?vue&type=style&index=0&id=77158611&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77158611",
  null
  
)

export default component.exports